<binding>
    <slot/>
    <script>
        import debounce from 'debounce';

        export default {
            setInput(validate) {
                let input = null;
                if (this.isValidator) {
                    this.validation.validate = (typeof this.props.validate !== 'undefined') 
                                                    ? this.props.validate : validate;
                    input = debounce((e)=> {
                        this.props.data.set(
                            this.props.name, 
                            e.target.value,
                            this.validation
                        );
                    }, 100);
                } else {
                    input = debounce((e)=> {
                        this.props.data[this.props.name] = e.target.value;
                    }, 100);
                }
                this.root.value = this.props.data[this.props.name];
                this.root.onkeyup = input;
                this.root.onchange = input;
            },
            setCheck() {
                let input = null;
                if (this.isValidator) {
                    input = debounce((e)=> {
                        let value = e.target.checked ? e.target.value : '';
                        this.props.data.set(
                            this.props.name, 
                            value, 
                            this.validation
                        );
                    }, 50);
                } else {
                    input = debounce((e)=> {
                        let value = e.target.checked ? e.target.value : '';
                        this.props.data[this.props.name] = value;
                    }, 50);
                }
                this.root.value = this.root.hasAttribute('val') ? this.root.getAttribute('val') : null;
                if (this.props.data[this.props.name] == this.root.value) {
                    this.root.checked = true;
                }
                this.root.onclick = input;
            },
            setTextArea() {
                let input = null;
                if (this.isValidator) {
                    input = debounce((e)=> {
                        this.props.data.set(
                            this.props.name, 
                            e.target.value, 
                            this.validation
                        );
                    }, 400);
                } else {
                    input = debounce((e)=> {
                        this.props.data[this.props.name] = e.target.value;
                    }, 400);
                }
                this.root.value = this.props.data[this.props.name];
                this.root.onkeyup = input;
                this.root.onchange = input;
            },
            setSelect() {
                let selector = null;
                if (this.isValidator) {
                    selector = debounce((e)=> {
                        this.props.data.set(
                            this.props.name,
                            this.root.options[this.root.selectedIndex].value,
                            this.validation
                        );
                    }, 50);
                } else {
                    selector = debounce((e)=> {
                        this.props.data[this.props.name] = this.root.options[this.root.selectedIndex].value;
                    }, 50);
                }
                for (let idx=0; idx < this.root.options.length; idx++) {
                    if (this.root.options[idx].value == this.props.data[this.props.name]) {
                        this.root.options[idx].selected = true;
                    } else {
                        this.root.options[idx].selected = false;
                    }
                }
                this.root.onchange = selector;
            },
            onValid() {
                if (this.root.parentElement.classList.contains('field')) {
                    this.field = this.root.parentElement;
                } else {
                    if (this.root.parentElement.parentElement.classList.contains('field')) {
                        this.field = this.root.parentElement.parentElement;
                    } else {
                        return ;
                    }
                }

                this.props.data.on('valid:'+ this.props.name, (valid) => {
                    if (valid) {
                        this.field.classList.remove('error');
                    } else {
                        if (!this.field.classList.contains('error')) {
                            this.field.classList.add('error');
                        }
                    }
                });
            },
            setBinding() {
                this.isValidator = false;
                this.validation = {
                    validate:  'string',
                    required:  false
                };

                if (typeof this.props.data !== 'undefined') {
                    if (typeof this.props.data.validate !== 'undefined') {
                        this.isValidator = true;
                        this.validation = {
                            validate:  (typeof this.props.validate !== 'undefined') ? this.props.validate : 'string',
                            required:  (typeof this.props.required !== 'undefined')
                        };
                        this.onValid();
                        this.props.data.isRequired(this.props.name, this.validation.required);
                    }
                }

                if (this.root.tagName === 'INPUT') {
                    switch(this.root.type) {
                        case 'text':
                        case 'search':
                        case 'telephone':
                            this.setInput('string');
                            break;
                        case 'checkbox':
                        case 'radio':
                            this.setCheck();
                            break;
                        case 'number':
                        case 'range':
                            this.setInput('number');
                            break;
                        case 'url':
                            this.setInput('url');
                            break;
                        case 'date':
                        case 'datetime':
                        case 'datetime-local':
                        case 'month':
                        case 'week':
                        case 'time':
                        case 'color':
                            this.setInput('string');
                            break;
                    }
                } else if (this.root.tagName === 'TEXTAREA') {
                    this.setTextArea();
                } else if (this.root.tagName === 'SELECT') {
                    this.setSelect();
                }
            },
            onMounted(props, state) {
                this.setBinding();
            },
            onUpdated(props, state) {
                this.setBinding();
            }
        }
    </script>
</binding>
